import { render, staticRenderFns } from "./combo.vue?vue&type=template&id=29a652c2&"
import script from "./combo.vue?vue&type=script&lang=js&"
export * from "./combo.vue?vue&type=script&lang=js&"
import style0 from "./combo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports